import '@babel/polyfill'
import 'mutationobserver-shim'
import './plugins/bootstrap-vue'
import './plugins/moment'
import './plugins/axios'
import './plugins/touch-events'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import lang from './language/de'

Vue.prototype.$trans = lang
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (store.getters.isAuthenticated && to.path !== '/login') {
    next()
  } else if (store.getters.isAuthenticated && to.path === '/login') {
    next('/')
  } else if (!store.getters.isAuthenticated && to.path === '/login') {
    next()
  } else {
    next('/login')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store,
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js